import dashboard from './dashboard';
import widget from './widget';
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
    items: [dashboard, widget]
};

export default menuItems;
